import { render, staticRenderFns } from "./HMHeadingWithButton.vue?vue&type=template&id=3dfb5413&scoped=true&"
import script from "./HMHeadingWithButton.vue?vue&type=script&lang=js&"
export * from "./HMHeadingWithButton.vue?vue&type=script&lang=js&"
import style0 from "./HMHeadingWithButton.vue?vue&type=style&index=0&id=3dfb5413&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfb5413",
  null
  
)

export default component.exports